import { Action } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { ContactUsFormData } from '../../types';

export enum ContactUsActionTypes {
  CREATE_SUPPORT_TICKET = '[StaticPages] CREATE_SUPPORT_TICKET',
  CREATE_SUPPORT_TICKET_SUCCESS = '[StaticPages] CREATE_SUPPORT_TICKET_SUCCESS',
  CREATE_SUPPORT_TICKET_FAIL = '[StaticPages] CREATE_SUPPORT_TICKET_FAIL',
  RESET_FORM = '[StaticPages] RESET_FORM',
}

export class CreateSupportTicket implements Action {
  readonly type = ContactUsActionTypes.CREATE_SUPPORT_TICKET;

  constructor(public payload: { data: ContactUsFormData }) {}
}

export class CreateSupportTicketSuccess implements Action {
  readonly type = ContactUsActionTypes.CREATE_SUPPORT_TICKET_SUCCESS;
}

export class CreateSupportTicketFail implements Action {
  readonly type = ContactUsActionTypes.CREATE_SUPPORT_TICKET_FAIL;

  constructor(public payload: { error: HttpError }) {}
}

export class ResetForm implements Action {
  readonly type = ContactUsActionTypes.RESET_FORM;
}

export type ContactUsActions =
  | CreateSupportTicket
  | CreateSupportTicketSuccess
  | CreateSupportTicketFail
  | ResetForm;
